import React, { useEffect } from 'react'
import {
  identifyUser,
  setUserProperty
} from '@/lib/amplitude/amplitudeAnalytics'
import { useUserAuthData } from '@/state/userAuth/hooks'
import { useUserProfileDisplay } from '@/state/userProfile/hooks'

export const AmplitudeUserUpdater = () => {
  const userAuthData = useUserAuthData()
  const { displayname } = useUserProfileDisplay()

  useEffect(() => {
    identifyUser(userAuthData?.id)
  }, [userAuthData?.id])

  useEffect(() => {
    if (displayname) {
      setUserProperty('displayName', displayname)
    }
  }, [displayname])

  useEffect(() => {
    const email = userAuthData?.email

    if (email) {
      setUserProperty('email', email)
    }
  }, [userAuthData?.email])

  return null
}
